import { Box, type BoxProps } from "@mui/material";
import type { FC, MouseEventHandler, ReactNode, Ref } from "react";

type Props = Omit<BoxProps, "children" | "onMouseDown" | "ref"> & {
	scrollRef?: Ref<HTMLDivElement>;
	onMouseDown?: MouseEventHandler<HTMLDivElement>;
	children: ReactNode;
};

export const HorizontalScrollContainer: FC<Props> = ({
	scrollRef,
	onMouseDown,
	sx,
	children,
	...boxProps
}) => (
	<Box
		ref={scrollRef}
		onMouseDown={onMouseDown}
		{...boxProps}
		sx={[
			{
				display: "flex",
				overflowX: "auto",
				scrollbarWidth: "none",
				"&::-webkit-scrollbar": { display: "none" },
			},
			...(Array.isArray(sx) ? sx : sx ? [sx] : []),
		]}
	>
		{children}
	</Box>
);
